export const basicBtns = [
  {
    label: "编辑",
    value: "create"
  },
  {
    label: "删除",
    value: "delete"
  },
  {
    label: "锁定",
    value: "lock"
  },
  {
    label: "解锁",
    value: "unlock"
  },
  {
    label: "打印",
    value: "print"
  }
]

export const stepIconColorMap = {
  before: "#E3F0FE",
  current: "#FDA23F",
  after: "#F5F7FA"
}

export const stepValueColorMap = {
  before: "#1989fa",
  current: "#FFF",
  after: "#878A90"
}
